import { element, isFunction } from 'angular';
export var ResolutionBreakpointsDirective = [
    '$window',
    '$timeout',
    function ($window, $timeout) {
        return {
            link: function ($scope) {
                var checkResolution = function () {
                    var windowWidth = $window.innerWidth;
                    var columnsInRow;
                    if ($scope.isListView) {
                        columnsInRow = 2;
                    }
                    else {
                        switch (true) {
                            case windowWidth < 768:
                                columnsInRow = 1;
                                break;
                            case windowWidth < 1200:
                                columnsInRow = 2;
                                break;
                            default:
                                columnsInRow = 3;
                                break;
                        }
                    }
                    if ($scope.columnsInRow === columnsInRow) {
                        return;
                    }
                    $scope.columnsInRow = columnsInRow;
                    if (isFunction($scope.onColumnsInRowChange)) {
                        $scope.onColumnsInRowChange({ columnsInRow: columnsInRow });
                    }
                };
                element($window).bind('resize', checkResolution);
                var $isListViewWatcher = $scope.$watch('isListView', checkResolution);
                var $scrollTriggerWatcher = $scope.$watch('isListView', function () {
                    $timeout(function () {
                        element($window).scroll();
                    });
                });
                $scope.$on('$destroy', function () {
                    element($window).off('resize', checkResolution);
                    $isListViewWatcher();
                    $scrollTriggerWatcher();
                });
                checkResolution();
            },
            restrict: 'A',
            scope: {
                isListView: '<',
                onColumnsInRowChange: '&?',
            },
        };
    },
];
